var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.$style.header,on:{"click":_vm.toggle}},[_vm._t("header",null,{"collapse":_vm.collapse})],2),_c('CollapsorTransition',{attrs:{"name":_vm.transition,"duration":_vm.duration}},[(!_vm.collapse)?_vm._t("default"):_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }